// extracted by mini-css-extract-plugin
export default {"base":"components-Shared-Icon-themes-PP-iconCheckmark__base--i4ik3"};